import React from 'react';
import { Link } from 'react-router-dom';
import xIcon from '../../assets/x-icon.png'; // Importiere das X-Icon

// Instagram Icon Component
const InstagramIcon = ({ size = 20, color = 'currentColor' }) => (
    <svg 
        xmlns="http://www.w3.org/2000/svg" 
        width={size} 
        height={size} 
        viewBox="0 0 24 24" 
        fill="none" 
        stroke={color} 
        strokeWidth="2" 
        strokeLinecap="round" 
        strokeLinejoin="round"
        style={{ verticalAlign: 'middle' }} // Adjust alignment if needed
    >
        <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
        <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
        <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
    </svg>
);

function Footer() {
  return (
    <div className="footer-wrapper">
    <footer className="footer">
    <div className="footer-content">
    <p>&copy; 2024 JewlAI. <Link to="/legal">Terms of Service and Privacy Policy</Link>.</p>
    <div>
        Write a message ✉️ <a href="mailto:jana@jewlai.com">jana@jewlai.com</a>
        <a href="https://x.com/janagoespro" target="_blank" rel="noopener noreferrer" className="twitter-link" style={{ marginLeft: '10px' }}>
            <img src={xIcon} alt="X Icon" className="twitter-icon" />
        </a>
        <a href="https://www.instagram.com/jewl_ai/" target="_blank" rel="noopener noreferrer" className="instagram-link" style={{ marginLeft: '10px', textDecoration: 'none', color: 'inherit' }}>
            <InstagramIcon />
            {/* Optional: Add text like @jewl_ai here if desired, e.g., <span style={{ marginLeft: '5px' }}>@jewl_ai</span> */}
        </a>
    </div>
    </div>
    </footer>
    </div>
  );
}

export default Footer;